
  <!---->
  <div class="row m-0 bg-dark1 background-color-in-footer" >

  <!-- <div class="row m-0 bg-dark1" style="position: relative; overflow: hidden; background-color: #012d78; padding:18px;"> -->
      <!-- <div class="container" style="border-bottom: 1px solid #a7a7a7; padding-bottom: 30px; margin-bottom: 20px;">
          <div class="row m-0">
              <div class="col-sm-4 foot-spec foot-com text-white">
                  <p style="margin-bottom: 30px;"><img src="assets/images/no-picture-available-icon-1.jpg" style="background-color: #ffffffbd; border-radius: 5px; padding: 5px; width: 150px;" /></p>
                  <p class="text-white" style="font-size: 16px;">sstravels-house Holidays Services is in business of Travel Booking, Flight Booking and Hotels booking since 2012.</p>
              </div>
              <div  class="col-sm-2 foot-spec foot-com">
                  <h4  style="margin-bottom: 30px; font-size: 18px; color: white;">Quick Links</h4>
                  <ul  class="ftlist text-white">
                      <li ><a  routerlink="/firstpage" class="text-white" href="/firstpage">Home</a></li>
                      <li ><a  routerlink="/aboutus" class="text-white" href="/aboutus">About Us</a></li>
                      <li ><a  routerlink="/bank" class="text-white" href="/bank">Bank Details</a></li>
                      <li ><a  routerlink="/contactus" class="text-white" href="/contactus">Contact Us</a></li>
                      <li ><a  routerlink="/privacy-policy" class="text-white" href="/privacy-policy">Privacy Policy</a></li>
                      <li ><a  routerlink="/terms-condition" class="text-white" href="/terms-condition">Terms of Use</a></li>
                  </ul>
              </div>
              <div class="col-sm-4 foot-spec foot-com">
                  <h4 style="margin-bottom: 30px; font-size: 18px; color: white;">What We Offer</h4>
                  <div class="wh-offer px-4">
                      <span class="tags-offer text-white">Fixed Departure Tickets</span><span class="tags-offer text-white">Airline Tickets</span> <span class="tags-offer text-white">Airline Deals </span>
                      <span class="tags-offer text-white">Group Fares </span> <span class="tags-offer text-white">Charter Aircrafts </span><span class="tags-offer text-white">Best Deals</span>
                  </div>
              </div>
              <div class="col-sm-4 foot-spec foot-com text-white">
                  <h4 style="margin-bottom: 30px; font-size: 18px;">Contact Us</h4>
                  <p class="text-white myFtr">
                      <span class="fw-500 text-white pr-3" style="font-size: 20px;"><i class="fa fa-map"></i></span>41 M.S Complex,2nd floor,Papanna lane, K.R Settypet, J.M.Road Cross, Bangalore 560 002,India
                  </p>
                  <p class="text-white myFtr">
                      <span class="fw-500 text-white pr-3" style="font-size: 20px;"><i class="fa fa-phone"></i></span>+91 080 41131131
                  </p>
                  <p  class="text-white myFtr">
                      <span  class="fw-500 text-white pr-3" style="font-size: 20px;"><i  class="fa fa-mobile"></i></span>+91 90350 70666, 99455 93172
                  </p>
                  <p class="text-white myFtr">
                      <a target="_blank" class="text-white" href="http://wa.me/+919035070666">
                          <span class="fw-500 text-white pr-3" style="font-size: 20px;"><i class="fa fa-whatsapp"></i></span>+91 90350 70666
                      </a>
                  </p>
                  <p class="text-white myFtr">
                      <span class="fw-500 text-white pr-3" style="font-size: 20px;"><i class="fa fa-envelope"></i></span>
                      <a target="_blank" class="text-white" href="mailto:angragventures@gmail.com">info@sstravels-house Holidays.in</a><br />
                  </p>
              </div>
          </div>
      </div> -->
      <div class="container text-white ft-18" *ngIf="!user">
          <div class="row m-0 justify-content-between text-center">
              <div class="col-md-12">
                <!-- <span *ngIf="settingdata!=''">{{settingdata?.footer_copywrite}} </span> -->
                <span>Copyrights {{currentYear}}</span>
              </div>
              <!-- <div class="col-">Copyright © 2024 sstravels-house Holidays. All Rights Reserved</div> -->
              <!-- <div class="col- footer-social">
                  <a href=""><i class="fa fa-facebook"></i></a><a href=""><i class="fa fa-twitter"></i></a>
                  <a href=""><i class="fa fa-instagram"></i></a>
              </div> -->
          </div>
      </div>
  </div>
  <!-- <div  class="box-fix">
      <div  class="email-box">
          <a  target="_blank" href="mailto:angragventures@gmail.com"><i  class="fa fa-envelope" style="color: #fff; font-size: 23px;"></i></a>
      </div>
      <div  class="whatsapp">
          <a  target="_blank" href="http://wa.me/+919035070666"><i  class="fa fa-whatsapp" style="color: #fff; font-size: 23px;"></i></a>
      </div>
      <div  class="whatsappgroup">
          <a  href="https://chat.whatsapp.com/Lxmn1qxhmXHJ3hCDsRn2PT" target="_blank"><img  src="assets/images/whatsapp-group.webp" style="width: 50px;" /></a>
      </div>
  </div> -->
